import axios, { AxiosResponse } from "axios";
import {IUser} from "../admin-users/admin-users.type";

/**
 * Получаем данные текущего пользователя
 */
export const getActiveUser = (): Promise<AxiosResponse<IUser>> => {
    return axios.get<IUser>('/services/isnaportal/api/user');
};
